import { Auth } from 'aws-amplify';
import axios, { AxiosInstance } from 'axios';

export abstract class BaseService {
  protected readonly client: AxiosInstance;

  constructor(protected readonly baseUrl = process.env.REACT_APP_PRODUCT_INVENTORY_SERVICE_BASE_URL) {
    const instance = axios.create({ baseURL: this.baseUrl });

    instance.interceptors.request.use(async (config) => {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken();

      if (idToken.payload['custom:vtaas-role'] === 'noaccess') {
        await Auth.signOut();
        throw Error('User does not have access, check "custom:vtaas-role".');
      }

      config.headers.Authorization = `Bearer ${idToken.getJwtToken()}`;
      return config;
    });

    this.client = instance;
  }
}
